import React, { Component } from "react";
import { Link } from "react-router-dom";
import 'bootstrap-icons/font/bootstrap-icons.css';

const LayerBar = ({ width = 72 }) => (
  <div className="jl-layers" style={{ width }} aria-hidden="true">
    {['#5A6672', '#7B8894', '#93A6B4', '#A3BACB', '#90AFC4', '#7FA4BE', '#D5232E'].map((c, i) => (
      <span key={i} style={{ background: c }} />
    ))}
  </div>
);

class JobLanding extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = this.props.funnelConfig.documentTitle;
  }

  get quizLink() {
    return `/job/quiz${this.props.location.search}`;
  }

  get infoLink() {
    return `/job/info${this.props.location.search}`;
  }

  renderStyles() {
    return (
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=Barlow:wght@400;500;600;700&display=swap');

        .jl-page {
          font-family: 'Barlow', system-ui, -apple-system, sans-serif;
          color: #1D2732;
          background: #fff;
          max-width: 480px;
          margin: 0 auto;
          padding-bottom: 96px;
        }
        .jl-display {
          font-family: 'Barlow Condensed', 'Barlow', sans-serif;
          font-weight: 700;
          letter-spacing: 0.01em;
          text-transform: uppercase;
        }
        .jl-eyebrow {
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.14em;
          font-size: 13px;
          color: #6B7D8D;
          margin-bottom: 6px;
        }
        .jl-layers { display: flex; flex-direction: column; gap: 2px; margin: 10px auto 20px; }
        .jl-layers span { display: block; height: 3px; border-radius: 2px; }

        .jl-cta {
          display: block;
          width: 100%;
          background: #D5232E;
          color: #fff;
          text-align: center;
          font-weight: 700;
          font-size: 16px;
          padding: 15px 20px;
          border-radius: 12px;
          text-decoration: none;
          box-shadow: 0 6px 16px rgba(213,35,46,.28);
          transition: transform .12s ease, background .12s ease;
        }
        .jl-cta:hover, .jl-cta:focus-visible { background: #B81C26; color: #fff; transform: translateY(-1px); }

        .jl-cta-secondary {
          display: block;
          width: 100%;
          background: transparent;
          color: #17293C;
          border: 2px solid #C2D2DE;
          text-align: center;
          font-weight: 600;
          font-size: 15px;
          padding: 13px 20px;
          border-radius: 12px;
          text-decoration: none;
          transition: border-color .12s ease, background .12s ease;
        }
        .jl-cta-secondary:hover, .jl-cta-secondary:focus-visible {
          border-color: #17293C; background: #EEF3F7; color: #17293C;
        }

        .jl-stickybar {
          position: fixed; bottom: 0; left: 50%; transform: translateX(-50%);
          width: 100%; max-width: 480px; z-index: 50;
          background: rgba(255,255,255,.96);
          backdrop-filter: blur(8px);
          border-top: 1px solid #E3EAF0;
          padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
        }
        .jl-stickybar .jl-cta { padding: 13px 16px; font-size: 15px; box-shadow: none; }

        .jl-hero { position: relative; height: 420px; overflow: hidden; background: #17293C; }
        .jl-hero img.jl-hero-img {
          width: 100%; height: 100%; object-fit: cover; object-position: center top;
          opacity: .92;
        }
        .jl-hero::after {
          content: ''; position: absolute; inset: 0;
          background: linear-gradient(180deg, rgba(23,41,60,.10) 0%, rgba(23,41,60,0) 32%, rgba(23,41,60,.9) 76%, #17293C 100%);
        }
        .jl-hero-content { position: absolute; left: 0; right: 0; bottom: 0; z-index: 2; padding: 20px; color: #fff; }
        .jl-hero-logo { position: absolute; top: 14px; right: 16px; z-index: 2; height: 40px; background: rgba(255,255,255,.95); border-radius: 8px; padding: 5px 10px; }
        .jl-hero-logo img { height: 100%; object-fit: contain; }
        .jl-chip {
          display: inline-block; background: #90AFC4; color: #14222F;
          font-family: 'Barlow Condensed', sans-serif; font-weight: 600; text-transform: uppercase;
          letter-spacing: .1em; font-size: 12.5px; padding: 4px 10px; border-radius: 4px; margin-bottom: 10px;
        }
        .jl-hero h1 { font-size: 28px; line-height: 1.1; margin: 0 0 6px; white-space: nowrap; }
        .jl-hero .jl-hero-sub { color: #C6D6E2; font-size: 15px; margin: 0; }

        .jl-facts {
          display: grid; grid-template-columns: 1fr 1fr;
          background: #17293C; color: #fff; padding: 0 16px 20px; gap: 8px;
        }
        .jl-fact {
          background: rgba(255,255,255,.13); border: 1px solid rgba(144,175,196,.55);
          border-radius: 10px; padding: 12px 12px; display: flex; gap: 10px; align-items: flex-start;
        }
        .jl-fact i { color: #90AFC4; font-size: 18px; margin-top: 1px; }
        .jl-fact b { display: block; font-size: 14px; line-height: 1.25; }
        .jl-fact span { font-size: 11.5px; color: #A9BFCF; line-height: 1.35; display: block; margin-top: 2px; }

        .jl-section { padding: 32px 20px 8px; text-align: center; }
        .jl-section h2 { font-size: 30px; line-height: 1.02; margin: 0; }

        .jl-badges { display: flex; justify-content: center; gap: 10px; margin: 18px 0 22px; flex-wrap: wrap; }
        .jl-badge {
          display: flex; align-items: center; gap: 8px;
          background: #EEF3F7; border: 1px solid #D8E3EB; border-radius: 999px;
          padding: 8px 14px; font-size: 13.5px; font-weight: 600; color: #17293C;
        }
        .jl-badge i { color: #D5232E; font-size: 16px; }

        .jl-footer { padding: 28px 20px calc(20px + env(safe-area-inset-bottom)); font-size: 12px; color: #7A8A98; text-align: center; }
        .jl-footer a { color: #3E5A70; }

        @media (prefers-reduced-motion: reduce) {
          .jl-cta, .jl-cta-secondary { transition: none; }
        }
      `}</style>
    );
  }

  renderHero() {
    const { companyLogo, companyName, aiDisclaimer, landing } = this.props.funnelConfig;
    return (
      <>
        <header className="jl-hero">
          <div className="jl-hero-logo">
            <img src={companyLogo} alt={companyName} />
          </div>
          <div style={{ position: 'absolute', top: 14, left: 16, zIndex: 2 }}>
            <img src={aiDisclaimer} alt="AI Disclaimer" style={{ height: 20, objectFit: 'contain' }} />
          </div>
          <img src={landing.heroImg} alt="" className="jl-hero-img" />
          <div className="jl-hero-content">
            <span className="jl-chip">{landing.chipText}</span>
            <h1 className="jl-display">{landing.heroTitle}</h1>
            <p className="jl-hero-sub">{landing.heroSubtitle}</p>
          </div>
        </header>
        <div className="jl-facts">
          {landing.facts.map((fact, i) => (
            <div key={i} className="jl-fact">
              <i className={`bi ${fact.icon}`} />
              <div><b>{fact.title}</b><span>{fact.subtitle}</span></div>
            </div>
          ))}
        </div>
      </>
    );
  }

  renderQuizPitch() {
    return (
      <section className="jl-section">
        <div className="jl-eyebrow">Deine Bewerbung</div>
        <h2 className="jl-display">Klick dich durch<br />unser Bewerbungsquiz</h2>
        <LayerBar />
        <div className="jl-badges">
          <span className="jl-badge"><i className="bi bi-stopwatch" /> Unter 60 Sekunden</span>
          <span className="jl-badge"><i className="bi bi-file-earmark-x" /> Kein Lebenslauf nötig</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <Link to={this.quizLink} className="jl-cta">
            <i className="bi bi-rocket-takeoff me-2" />Lass uns direkt loslegen!
          </Link>
          <Link to={this.infoLink} className="jl-cta-secondary">
            <i className="bi bi-info-circle me-2" />Mehr Infos zum Job
          </Link>
        </div>
      </section>
    );
  }

  renderStickyBar() {
    return (
      <div className="jl-stickybar">
        <Link to={this.quizLink} className="jl-cta">
          Jetzt bewerben <span style={{ fontWeight: 400, opacity: .85 }}>· dauert unter 60 Sek.</span>
        </Link>
      </div>
    );
  }

  renderFooter() {
    return (
      <footer className="jl-footer">
        <p style={{ marginBottom: 18 }}>
          Aus Gründen der Lesbarkeit wird auf dieser Website darauf verzichtet, durchgehend geschlechtsspezifische
          Formulierungen zu verwenden. Soweit personenbezogene Bezeichnungen nur in männlicher Form angeführt sind,
          beziehen sie sich auf Mann, Frau und Divers in gleicher Weise. Dies soll jedoch keinesfalls eine
          Geschlechterdiskriminierung oder eine Verletzung des Gleichheitsgrundsatzes zum Ausdruck bringen.
        </p>
        <div style={{ fontWeight: 600, color: '#1D2732' }}>Powered by ZoneAid</div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 16, flexWrap: 'wrap' }}>
          <Link target="_blank" rel="noopener noreferrer" to="/job/impressum">Impressum</Link>
          <Link target="_blank" rel="noopener noreferrer" to="/job/agb">Nutzungsbedingungen</Link>
          <Link target="_blank" rel="noopener noreferrer" to="/job/datenschutz">Datenschutzerklärung</Link>
        </div>
      </footer>
    );
  }

  render() {
    return (
      <div className="jl-page">
        {this.renderStyles()}
        {this.renderHero()}
        {this.renderQuizPitch()}
        {this.renderFooter()}
        {this.renderStickyBar()}
      </div>
    );
  }
}

export default JobLanding;
